import React, { forwardRef } from 'react';

const EmptyRow = forwardRef(({ height = '20px' }, ref) => {
  return <tr ref={ref} style={{ height: height }} />;
});

export default EmptyRow;
